import { render, staticRenderFns } from "./MarEvent2024.vue?vue&type=template&id=55df82ae&scoped=true"
import script from "./MarEvent2024.vue?vue&type=script&lang=js"
export * from "./MarEvent2024.vue?vue&type=script&lang=js"
import style0 from "./MarEvent2024.vue?vue&type=style&index=0&id=55df82ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df82ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55df82ae')) {
      api.createRecord('55df82ae', component.options)
    } else {
      api.reload('55df82ae', component.options)
    }
    module.hot.accept("./MarEvent2024.vue?vue&type=template&id=55df82ae&scoped=true", function () {
      api.rerender('55df82ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/components/MarEvent2024.vue"
export default component.exports